// src/Br.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Br_default = createIcon({
  displayName: "Br",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        id: "green",
        x: "1",
        y: "1",
        width: "48",
        height: "32",
        fill: "#00AE82"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "yellow",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 3L5 17L25 31L45 17L25 3Z",
        fill: "#FBB43A"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "blue",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34 17C34 12.0294 29.9706 8 25 8C20.0294 8 16 12.0294 16 17C16 21.9706 20.0294 26 25 26C29.9706 26 34 21.9706 34 17Z",
        fill: "#0070B8"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.9399 18.0453C30.5509 15.0689 26.1074 13.2642 21.2424 13.2642C19.6319 13.2642 18.0676 13.4619 16.5724 13.8345C16.3705 14.3718 16.2185 14.9334 16.1221 15.5138C17.7433 15.0262 19.4623 14.7642 21.2424 14.7642C26.0328 14.7642 30.38 16.6618 33.5732 19.7464C33.748 19.2002 33.8721 18.6314 33.9399 18.0453Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Br_default
};
